import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import FilterRequest from '../../../Spirit/Common/Extensions/Models/FilterRequest';
import PaginationRequest from '../../../Common/RequestModels/PaginationRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import BackgroundCategoryAddRequest from '../../../Spirit/Admin/Interfaces/Models/BackgroundCategoryService/BackgroundCategoryAddRequest';
import BackgroundCategoriesGetListResponse from '../../../Spirit/Admin/Interfaces/Models/BackgroundCategoryService/BackgroundCategoriesGetListResponse';
import BackgroundCategoryGetDetailResponse from '../../../Spirit/Admin/Interfaces/Models/BackgroundCategoryService/BackgroundCategoryGetDetailResponse';

export default class BackgroundCategoryService {
	webApiService: WebApiService;
	AddEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteEvent = new Events<WsResponseModelT<Boolean>>();
	GetDetailEvent = new Events<WsResponseModelT<BackgroundCategoryGetDetailResponse>>();
	GetListEvent = new Events<WsResponseModelT<BackgroundCategoriesGetListResponse>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('BackgroundCategoryService', 'Add', (res: WsResponseModelT<Boolean>) => {
			self.AddEvent.trigger(res);
		});
		webApiService.on('BackgroundCategoryService', 'Delete', (res: WsResponseModelT<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('BackgroundCategoryService', 'GetDetail', (res: WsResponseModelT<BackgroundCategoryGetDetailResponse>) => {
			self.GetDetailEvent.trigger(res);
		});
		webApiService.on('BackgroundCategoryService', 'GetList', (res: WsResponseModelT<BackgroundCategoriesGetListResponse>) => {
			self.GetListEvent.trigger(res);
		});
	}
	Add(request: BackgroundCategoryAddRequest = null) {
        this.webApiService.send('BackgroundCategoryService', 'Add' , request);
    }
	Delete(id: number = 0) {
        this.webApiService.send('BackgroundCategoryService', 'Delete' , id);
    }
	GetDetail(id: number = 0) {
        this.webApiService.send('BackgroundCategoryService', 'GetDetail' , id);
    }
	GetList(request: FilterRequest = null) {
        const normalizedRequest = request || new FilterRequest();
		if (!normalizedRequest.Pagination) {
			normalizedRequest.Pagination = new PaginationRequest({
				Skip: 0,
				Take: 1000
			});
		}
        this.webApiService.send('BackgroundCategoryService', 'GetList' , normalizedRequest);
    }
	async addAsync(request: BackgroundCategoryAddRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Add.bind(this), this.AddEvent)(request);
	}
	async deleteAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
	async getDetailAsync(id: number = 0): Promise<BackgroundCategoryGetDetailResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetDetail.bind(this), this.GetDetailEvent)(id);
	}
	async getListAsync(request: FilterRequest = null): Promise<BackgroundCategoriesGetListResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
}
